import React, { useContext, useState } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import Input from '../../../../../components/input'
import Button from '../../../../../components/button'
import PersonAdd from '@material-ui/icons/PersonAdd'
import CircularProgress from '@material-ui/core/CircularProgress'
import { createCampaign } from '../../../../../api'
import { AuthContext } from '../../../../../auth-context'
import { DashboardContext } from '../../../dashboard-context'
import { ErrorMessage } from '../../../../../components/error-message'

const OuterWrapper = styled.div`
  flex-shrink: 0;
  @media(max-width: 1200px) {
    margin-bottom: 32px;
    width: 100%;
  }
`

const Container = styled.div`
  background: #FFF;
	border-radius: 8px;
	box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 540px;
  padding: 24px;

  @media(max-width: 900px) {
    padding: 16px;
  }
`

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: ${props => props.theme.font.primary};
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const ClearButton = styled(Button)`
  background: none;
  box-shadow: none;
  color: #888;
  margin: 0;
  &:hover {
    background: #EFEFEF;
  }
  &:active {
    background: #DDD;
    box-shadow: none;
    color: #555;
  }
`

const AddButton = styled(Button)`
  margin: 0;
  margin-left: 16px;
`

const AddCampaign = (props) => {
  const { user, updateUser } = useContext(AuthContext)
  const { openSnackbar } = useContext(DashboardContext)
  const [loading, updateLoading] = useState(false)
  const [name, updateName] = useState('')
  const [nameError, updateNameError] = useState(false)
  const [error, updateError] = useState('')

  const handleClear = () => {
    updateName('')
    updateNameError(false)
    updateError('')
  }

  const handleAdd = () => {
    if (name === '') {
      updateError('Please enter a name for the campaign.')
      updateNameError(true)
    } else {
      const lcName = name.toLowerCase()
      let duplicate = false
      for (let n = 0; n < props.campaigns.length; ++n) {
        if (props.campaigns[n].name.toLowerCase() === lcName) {
          duplicate = true
          break
        }
      }
      if (duplicate) {
        updateError('There is already a campaign with that name.')
        updateNameError(true)
      } else {
        updateLoading(true)
        createCampaign(user.id, name).then((res) => {
          openSnackbar('Campaign successfully added.', false)
          props.history.push('/dashboard/campaign/' + res.data.id)
        })
      }
    }
  }

  return props.campaignsState !== 2 && !loading ? (
    <OuterWrapper>
      <Container className={props.className}>
        <CircularProgress size={32} />
      </Container>
    </OuterWrapper>
  ) : (
    <OuterWrapper>
      <Container className={props.className}>
        <HeaderContainer>
          <Label>
            <PersonAdd /> Add a Campaign
          </Label>
        </HeaderContainer>

        <div style={{fontSize: '16px', fontStyle: 'italic', color: '0x676767', marginBottom: '20px'}}>Use this to create your own campaign from scratch.</div>

        <Input
          error={nameError}
          label="Name"
          value={name}
          onChange={updateName}
        />

        {error !== '' && 
          <ErrorMessage>
            {error}
          </ErrorMessage>
        }
        <ButtonContainer>
          <ClearButton
            label="Clear"
            onClick={handleClear}
          />
          <AddButton 
            label="Add Campaign"
            isLoading={loading}
            onClick={handleAdd}
          />
        </ButtonContainer>
      </Container>
    </OuterWrapper>
  )
}

export default withRouter(AddCampaign)